export const billingKeys = {
  status: (tenantId: number | null) => ['billingStatus', tenantId] as const,
  details: (tenantId: number | null) => ['billing', tenantId] as const,
  invoices: (tenantId: number | null) => [...billingKeys.details(tenantId), 'invoices'] as const,
  offers: (tenantId: number | null) => [...billingKeys.details(tenantId), 'offers'] as const,
  checkoutOptions: (tenantId: number | null) => [...billingKeys.details(tenantId), 'checkoutOptions'] as const,
  scheduledPlanChange: (tenantId: number | null) => [...billingKeys.details(tenantId), 'scheduledPlanChange'] as const,
  upcomingAmount: (tenantId: number | null) => [...billingKeys.details(tenantId), 'upcomingAmount'] as const,
  paymentMethod: (tenantId: number | null) => [...billingKeys.details(tenantId), 'paymentMethod'] as const,
  checkoutSummary: (sessionId: string | undefined) => ['billingCheckoutSummary', sessionId] as const,
  products: () => ['billingProducts', 'list'] as const,
  pricing: (tenantId: number | null) => ['billingProducts', 'marketPricing', tenantId] as const,
};
